module.exports = __webpack_public_path__ + "static/media/icon_162.b2324c24.svg";